import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { saveLinks } from "../../../../actions/contentActions";
import { connect } from "react-redux";
import { t } from "../../../../i18n";
import {
  AddPlus,
  AddPlusCircle,
  CardsService,
  SearchIcon,
  Show,
  Trash,
} from "../../normalizer";
import { startFetch, endFetch } from "../../../../actions/generalActions";
import Popup from "./Popup";
import InspectCard from "./InspectCard";
import CustomButton from "../../shared/CustomButton";
import CustomDataTable from "../../shared/CustomDataTable";
import KeyDropdownValue from "../../shared/KeyDropdownValue";
import InputKeyValue from "../../shared/InputKeyValue";

const CardTable = (props) => {
  const [CampaignCards, setCampaignCards] = useState(null);
  const [UserCards, setUserCards] = useState(null);
  const [ToCancel, setToCancel] = useState(false);
  const [ToCharge, setToCharge] = useState(false);
  const [ToRegister, setToRegister] = useState(false);
  const [ToChargeNumber, setToChargeNumber] = useState("");
  const [SelectedCard, setSelectedCard] = useState(null);
  const [response, setResponse] = useState(0);
  const [toInspect, setToInspect] = useState(null);
  const [cardToRegister, setCardToRegister] = useState("");
  const [typeToRegister, setTypeToRegister] = useState("");

  const [cardsLookup, setCardsLookup] = useState([]);
  const [cardType, setCardType] = useState("");
  const [cardNumberFilter, setCardNumberFilter] = useState("");
  const [cardPage, setCardPage] = useState(1);
  const [cardTotalPages, setCardTotalPages] = useState(1);

  const [stateLookup, setStateLookup] = useState([]);
  const [cardState, setCardState] = useState("");

  const [rechargeItems, setRechargeItems] = useState([]);
  const [rechargePage, setRechargePage] = useState(1);
  const [rechargeTotalPages, setRechargeTotalPages] = useState(1);

  // Debounced card-number: API is called 400 ms after the user stops typing
  const [debouncedCardNumber, setDebouncedCardNumber] = useState("");

  useEffect(() => {
    getCampaignCards();
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedCardNumber(cardNumberFilter);
    }, 400);
    return function() { clearTimeout(timer); };
  }, [cardNumberFilter]);

  useEffect(() => {
    getUserCards();
  }, [cardType, cardState, cardPage, debouncedCardNumber]);

  useEffect(() => {
    if (CampaignCards) {
      setCardsLookup(
        CampaignCards.map((card) => ({
          id: card.card_type.id,
          name: card.card_type.name,
        })),
      );
    }
  }, [CampaignCards]);

  //#region API CALLS
  // Done
  function getCampaignCards() {
    const { user, campaign } = props;

    const payload = {
      clientSlug: user.client.slug,
      campaignSlug: campaign.slug,
    };

    props.startTransaction(() =>
      CardsService.getCampaignCards(payload).then((response) => {
        setCampaignCards(response.data["campaign/card_types"]);
      }),
    );
  }

  // Done
  function getUserCards() {
    const { user, campaign } = props;

    const payload = {
      clientSlug: user.client.slug,
      campaignSlug: campaign.slug,
      state: cardState || undefined,
      number: cardNumberFilter || undefined,
      card_type_id: cardType || undefined,
      page: cardPage,
    };

    props.startTransaction(() =>
      CardsService.getUserCards(payload).then((response) => {
        const cards = response.data["user/cards"] || [];
        setUserCards(cards);
        if (response.data.pagination) {
          setCardTotalPages(response.data.pagination.total_pages || 1);
        }
        // Derive unique states from the first unfiltered load only, so the
        // dropdown always reflects real backend codes/labels and stays stable
        // while the user applies filters.
        if (!cardState && !cardType && !cardNumberFilter && stateLookup.length === 0) {
          const seen = new Set();
          const states = [];
          cards.forEach(function(card) {
            if (card.state && !seen.has(card.state.code)) {
              seen.add(card.state.code);
              states.push({ id: card.state.code, name: card.state.label });
            }
          });
          if (states.length > 0) setStateLookup(states);
        }
      }),
    );
  }

  function fetchRecharges(cardId, page) {
    const { user, campaign } = props;
    const payload = {
      clientSlug: user.client.slug,
      campaignSlug: campaign.slug,
      cardId,
      page,
    };
    props.startTransaction(() =>
      CardsService.getCardRecharges(payload).then((response) => {
        setRechargeItems(response.data.recharges || []);
        setRechargeTotalPages(
          response.data.pagination ? response.data.pagination.total_pages : 1
        );
        setRechargePage(page);
      }),
    );
  }

  function handleInspect(card) {
    setToInspect(card);
    fetchRecharges(card.id, 1);
  }

  function handleRechargePageChange(newPage) {
    if (toInspect) fetchRecharges(toInspect.id, newPage);
  }

  // Done
  function PutChargeCard() {
    const { user, campaign } = props;

    var points = SelectedCard.recharge_options.find(
      (e) => e.value == ToChargeNumber,
    ).points;

    const payload = {
      clientSlug: user.client.slug,
      campaignSlug: campaign.slug,
      cardId: SelectedCard.id,
      value: ToChargeNumber,
      points: points,
    };

    props.startTransaction(() =>
      CardsService.putChargeUserCard(payload).then((response) => {
        setResponse(response.status);
      }),
    );
  }

  // Done
  function PutcancelCard() {
    const { user, campaign } = props;

    const payload = {
      clientSlug: user.client.slug,
      campaignSlug: campaign.slug,
      cardId: SelectedCard.id,
    };

    props.startTransaction(() =>
      CardsService.putCancelUserCard(payload)
        .then((response) => {
          //setResponse(response.status) -----
          setResponse(200);
        })
        .catch((e) => {
          setResponse(-1);
        }),
    );
  }

  // Done
  function PutRegisterCard() {
    const { user, campaign } = props;

    const payload = {
      clientSlug: user.client.slug,
      campaignSlug: campaign.slug,
      cardType: CampaignCards.find((e) => e.card_type.name == typeToRegister)
        .card_type.id,
      number: cardToRegister,
    };

    props.startTransaction(() =>
      CardsService.putRegisterUserCard(payload).then((response) => {
        setResponse(response.status);
      }),
    );
  }

  //#endregion

  //#region Charge Event

  function RunToCharge(Card) {
    setToCharge(true);
    setSelectedCard(Card);
  }

  function clearChargeVariables() {
    setSelectedCard(null);
    setToChargeNumber("");
    setResponse(0);
  }

  function ComfirmCharge() {
    PutChargeCard();
  }

  //#endregion

  //#region  Cancel Event

  function RunToCancel(Card) {
    setToCancel(true);
    setSelectedCard(Card);
  }

  function clearCancelVariables() {
    setSelectedCard(null);
    setResponse(0);
  }

  function ComfirmCancel() {
    PutcancelCard();
    setSelectedCard(null);
    window.location.reload(false);
  }

  //#endregion

  //#region  Register Event

  function RunToRegister() {
    setToRegister(true);
  }

  function clearResgisterVariables() {
    setTypeToRegister("");
    setCardToRegister("");
    setSelectedCard(null);
    setResponse(0);
  }

  function ComfirmRegister() {
    console.log(SelectedCard);
    PutRegisterCard();
    setSelectedCard(null);
    window.location.reload(false);
  }

  //#endregion

  function formatCurrency(value) {
    return new Intl.NumberFormat("pt-PT", {
      style: "currency",
      currency: "EUR",
    }).format(value);
  }

  function CheckPermission(array, string) {
    // Guard: available_actions may be null/undefined depending on API state
    if (!Array.isArray(array)) return false;
    return array.some((a) => a && a.code === string);
  }

  function IsRegistered(Value) {
    if (Value.registrar == null) {
      return false;
    }

    if (Value.registrar.name == null) {
      return false;
    }

    return true;
  }

  // Column definitions for CardTable
  const cardTableClass = "card-table";
  const columns = [
    {
      key: "card_type",
      label: t("gamification2026.card-table.card-type"),
      render: (_v, item) => item.card_type.name,
    },
    { key: "number", label: t("gamification2026.card-table.card-number") },
    {
      key: "state",
      label: t("gamification2026.card-table.state"),
      render: (_v, item) => (
        <div
          className={`data-table__cell-content data-table__cell-content--state data-table__cell-content--state-${item.state.code} ${cardTableClass}__cell-content ${cardTableClass}__cell-content--state ${cardTableClass}__cell-content--state-${item.state.code}`}
        >
          {item.state.label}
        </div>
      ),
    },
    {
      key: "holder",
      label: t("gamification2026.card-table.holder"),
      render: (_v, item) => (IsRegistered(item) ? item.registrar.name : t("gamification2026.card-table.to-register")),
    },
    {
      key: "balance",
      label: t("gamification2026.card-table.total-loaded"),
      render: (_v, item) => formatCurrency(item.balance),
    },
    {
      key: "actions",
      label: t("gamification2026.card-table.actions"),
      sortable: false,
      render: (_v, item) => (
        <div className="card-table__actions">
          {CheckPermission(item.available_actions, "view_balance") && (
            <CustomButton link small tight onClick={() => handleInspect(item)}>
              <Show />
              {t("gamification2026.card-table.action-details")}
            </CustomButton>
          )}
          {CheckPermission(item.available_actions, "recharge") && (
            <CustomButton link small tight onClick={() => RunToCharge(item)}>
              <AddPlusCircle />
              {t("gamification2026.card-table.action-topup")}
            </CustomButton>
          )}
          {CheckPermission(item.available_actions, "cancel") && (
            <CustomButton link small tight onClick={() => RunToCancel(item)}>
              <Trash />
              {t("gamification2026.card-table.action-cancel")}
            </CustomButton>
          )}
        </div>
      ),
    },
  ];

  // Custom row renderer for cards
  const renderCardRow = (card, index, className) => {
    return (
      <tr
        key={card.number || index}
        className={`data-table__row ${className}__row`}
      >
        <td
          className={`data-table__cell ${className}__cell ${className}__cell--card_type`}
        >
          {card.card_type.name}
        </td>
        <td
          className={`data-table__cell ${className}__cell ${className}__cell--number`}
        >
          {card.number}
        </td>
        <td
          className={`data-table__cell data-table__cell--state data-table__cell--state-${card.state.code} ${className}__cell ${className}__cell--state ${className}__cell--state-${card.state.code}`}
        >
          <div
            className={`data-table__cell-content data-table__cell-content--state data-table__cell-content--state-${card.state.code} ${className}__cell-content ${className}__cell-content--state ${className}__cell-content--state-${card.state.code}`}
          >
            {card.state.label}
          </div>
        </td>
        <td
          className={`data-table__cell ${className}__cell ${className}__cell--holder`}
        >
          {IsRegistered(card)
            ? card.registrar.name
            : t("gamification2026.card-table.to-register")}
        </td>
        <td
          className={`data-table__cell ${className}__cell ${className}__cell--balance`}
        >
          {formatCurrency(card.balance)}
        </td>
        <td
          className={`data-table__cell ${className}__cell ${className}__cell--actions`}
        >
          <div className="card-table__actions">
            {CheckPermission(card.available_actions, "view_balance") && (
              <CustomButton link small tight onClick={() => handleInspect(card)}>
                <Show />
                {t("gamification2026.card-table.action-details")}
              </CustomButton>
            )}
            {CheckPermission(card.available_actions, "recharge") && (
              <CustomButton link small tight onClick={() => RunToCharge(card)}>
                <AddPlusCircle />
                {t("gamification2026.card-table.action-topup")}
              </CustomButton>
            )}
            {CheckPermission(card.available_actions, "cancel") && (
              <CustomButton link small tight onClick={() => RunToCancel(card)}>
                <Trash />
                {t("gamification2026.card-table.action-cancel")}
              </CustomButton>
            )}
          </div>
        </td>
      </tr>
    );
  };

  function onChangeCardType(option) {
    setCardType(option ? option.id : "");
    setCardPage(1);
  }

  function onChangeCardState(option) {
    setCardState(option ? option.id : "");
    setCardPage(1);
  }

  function onCardNumberSearch(e) {
    setCardNumberFilter(e.target.value);
    setCardPage(1);
  }

  return (
    <div className="card-table-container">
      {toInspect == null && (
        <>
          <div className="card-filters-container">
            <div className="card-filters-card-type">
              <InputKeyValue
                title={t("gamification2026.card-table.column-card-number")}
                name="cardNumber"
                leftIcon={<SearchIcon />}
                placeholder={t("gamification2026.card-table.search-card")}
                value={cardNumberFilter}
                onChange={onCardNumberSearch}
              />
            </div>
            <div className="card-filters-card-number">
              <KeyDropdownValue
                title={t("gamification2026.card-table.column-card-type")}
                name="cardType"
                options={cardsLookup}
                onChange={onChangeCardType}
                placeholder={t("gamification2026.card-table.select")}
                isClearable
              />
            </div>
            <div className="card-filters-card-state">
              <KeyDropdownValue
                title={t("gamification2026.card-table.column-state")}
                name="cardState"
                options={stateLookup}
                onChange={onChangeCardState}
                placeholder={t("gamification2026.card-table.select")}
                isClearable
              />
            </div>
          </div>
          <section className="card-table-section">
            <CustomDataTable
              className="card-table"
              columns={columns}
              data={UserCards || []}
              renderRow={renderCardRow}
              rowKey={(card) => card.number}
              emptyMessage={t("gamification2026.card-table.no-results")}
              pagination={{
                totalPages: cardTotalPages,
                currentPage: cardPage,
                onPageChange: (data) => setCardPage(data.selected + 1),
              }}
            />
            {ToCancel && (
              <Popup
                isOpenValue={true}
                Response={response}
                Title={`Eliminar cartão nº ${SelectedCard.number}`}
                clearVariables={clearCancelVariables}
                Selected={SelectedCard}
                ToExcute={ComfirmCancel}
                Condition={setToCancel}
                EventType="Cancel"
              ></Popup>
            )}
            {ToCharge && (
              <Popup
                isOpenValue={true}
                Response={response}
                Title={`Carregar cartão nº ${SelectedCard.number}`}
                clearVariables={clearChargeVariables}
                Selected={SelectedCard}
                ToExcute={ComfirmCharge}
                Condition={setToCharge}
                Value={ToChargeNumber}
                ToChangeValue={setToChargeNumber}
                EventType="Charge"
              ></Popup>
            )}
          </section>
          <div className="card-table-actions-container">
            <CustomButton secondary tight onClick={(event) => RunToRegister()}>
              <AddPlus />
              {t("gamification2026.card-table.add-card")}
            </CustomButton>
            {ToRegister && (
              <Popup
                isOpenValue={true}
                Response={response}
                Title={"Registar cartão"}
                clearVariables={clearResgisterVariables}
                ToExcute={ComfirmRegister}
                Condition={setToRegister}
                Value={cardToRegister}
                ToChangeValue={setCardToRegister}
                Value_={typeToRegister}
                ToChangeValue_={setTypeToRegister}
                EventType="Register"
                CampaignCards={CampaignCards}
              ></Popup>
            )}
          </div>
        </>
      )}
      {toInspect && (
        <InspectCard
          Condition={toInspect}
          setCondition={setToInspect}
          Selected={toInspect}
          recharges={rechargeItems}
          rechargePage={rechargePage}
          rechargeTotalPages={rechargeTotalPages}
          onRechargePageChange={handleRechargePageChange}
        />
      )}
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    saveLinks: (links) => {
      dispatch(saveLinks(links));
    },
    startFetch: () => {
      dispatch(startFetch());
    },
    endFetch: () => {
      dispatch(endFetch());
    },
  };
}

export default withRouter(connect(null, mapDispatchToProps)(CardTable));
